import requestProvider from "./axiosHandler";

const getAllShippingOrders = () => {

    return requestProvider
        .get('/shipping-order/get-all')
}

const createShippingOrder = (list) => {

    return requestProvider
        .post('/shipping-order', list)
}

const updateShippingOrder = (list) => {

    return requestProvider
        .put(`/shipping-order`, list)
}

const deleteShippingOrder = (id) => {

    return requestProvider
        .delete(`/shipping-order/${id}`)
}

const getShippingOrdersById = (id) => {

    return requestProvider
        .get(`/shipping-order/${id}`)
}

const completeByPrint = (id) => {
    return requestProvider
        .post(`shipping-order/completed/${id}`)
}

const shippingOrderFilter = (list) => {
    return requestProvider
        .post('/shipping-order/filter', list)
};

const getShippingOrderWithPage = (list) => {
    return requestProvider
        .post('/shipping-order/page-filter', list);
}

export {shippingOrderFilter, getAllShippingOrders, createShippingOrder, updateShippingOrder, deleteShippingOrder, getShippingOrdersById, completeByPrint, getShippingOrderWithPage}